<template>
  <div>
    <div class="columns" v-show="showList">
        <div class="column">
          <section class="hero is-info" v-show="showList">
            <article class="message" v-show="!dataAlready">
              <div class="message-body">กำลังดึงข้อมูล...</div>
            </article>
            <table class="table is-bordered is-strip" style="width:100%" v-show="dataAlready">
            <thead>
              <tr>
                <th><abbr title="runNo">ลำดับที่</abbr></th>
                <th><abbr title="frameNo">Frame No</abbr></th>
                <th><abbr title="licenseNo">License No</abbr></th>
                <th><abbr title="customerName">Customer Name</abbr></th>
                <th><abbr title="userId">userId</abbr></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="car in carList" v-bind:key="car.id" v-if="car.userId != -1 && car.userId">
                <td>{{car.runNo}}</td>
                <td>{{car.frameNo}}</td>
                <td>{{car.licenseNo}}</td>
                <td>{{car.customerName}}</td>
                <td>{{car.userId}}</td>
              </tr>
            </tbody>
          </table>
          </section>
        </div>
    </div>
  </div>
</template>
<style>
.banner {
  text-align:center;background-color:#000;
}
.error {
  color: red;
}
</style>
<script>
export default {
  name: 'Progress',
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
  },
  data: () => ({
    showComplete: false,
    dataAlready: false,
    confirmSuccess: false,
    showList: true,
    carList: null
  }),
  mounted () {
    let _this = this
    _this.getCarList()
  },
  methods: {
    getCarList () {
      let _this = this
      this.$axios
        .get(`${this.$apiUrl}getCarAll`)
        .then(response => {
          _this.dataAlready = true
          _this.carList = response.data
          _this.showList = true
        })
    },
    closeWindow () {
      this.$liff.closeWindow()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Export.vue